module.exports = __webpack_public_path__ + "3da4ae0bef6d94083a9fdc190a3728ec.svg";